import _ from 'underscore';
import { requiredFeatures as taxFormFeatures } from '@bingads-webui-cc-react/tax-form';

const selfFeatures = [
  'EnhancedABLP1',
  'ABLColombiaTax',
  'GoogleAuthIntlNewSignInPage',
  'MoveHKToCountry',
  'ChinaEntity1979',
];

const features = _.chain(taxFormFeatures)
  .values()
  .union(selfFeatures)
  .value();

/**
 * The names of the required features for the account business location component.
 * Any features not listed here should *not* be expected to be passed in
 * through the permissions object by the host components.
 * The returned object is a map where each entry has the key identical to the value,
 * both representing the name of a required feature.
 */
export const requiredFeatures = _.object(features, features);
